import { Ref, watch } from "vue";
import { useHotelsStore } from "@/stores/hotels";
import { storeToRefs } from "pinia";
import { useDebounceFn } from "@vueuse/core";

const useHotelSearch = (query: Ref<string>) => {
  const { setSearchQuery } = useHotelsStore();
  const { searchQuery } = storeToRefs(useHotelsStore());

  const searchHotels = useDebounceFn(() => {
    setSearchQuery(query.value);
  }, 150);

  watch(query, (value) => {
    value.length > 1 ? searchHotels() : setSearchQuery("");
  });

  return {
    searchQuery,
    setSearchQuery,
  };
};

export default useHotelSearch;
